import { NID_SVC_TYPE } from '..'

const commonLinks = {
  ABOUT_VISIT_HISTORY: 'https://m.post.naver.com/viewer/postView.nhn?volumeNo=28607895&memberNo=41517755',
  ADDRESS_DETAIL: 'https://m.map.naver.com/search2/search.nhn?query=',
  ADPOST_POLICY: 'https://adpost.naver.com/help/policy',
  ALL_SERVICES: 'https://m.naver.com/services.html',
  ANNOUNCE: 'https://m.blog.naver.com/nv_placemy',
  BOOKING_POLICY: 'https://booking.naver.com/policy',
  BOOKING_ANNOUNCE: 'https://booking.naver.com/announcements',
  BOOKING_BLOG: 'https://blog.naver.com/PostList.naver?blogId=n_bookingmt01',
  BOOKING_DIRECTPAY: 'https://booking.naver.com/my/direct-pay-methods',
  BOOKING_TALK: 'https://talk.naver.com/wce2sb',
  CS_PLACE_MATCH: 'https://help.naver.com/support/alias/myplace/myplace_21.naver',
  CS_REVIEW_HIDE: 'https://help.naver.com/support/alias/myplace/myplace_16.naver',
  CS_REVIEW_REPORTED: 'https://help.naver.com/support/alias/myplace/myplace_64.naver',
  CS_RECEIPT_SCANFAIL: 'https://help.naver.com/support/alias/myplace/myplace_08.naver',
  CS_RECEIPT_CHECKEDIN: 'https://help.naver.com/support/contents/faqContentsView.help?contentsNo=11540',
  CS_RECEIPT_SUBMIT_STANDARD: 'https://help.naver.com/support/alias/myplace/myplace_19.naver',
  CS_INQUIRY: 'https://help.naver.com/inquiry/input.help?categoryNo=16041&serviceNo=19485&lang=ko',
  CUSTOMER_SERVICE: 'https://help.naver.com/service/19485/category/bookmark?lang=ko',
  LOCATION_AGREEMENT: 'https://nid.naver.com/iasystem/m_pop.nhn',
  LOCATION_DEVICE_SETTING_HELP: 'https://help.naver.com/support/alias/myplace/myplace_39.naver',
  LOGIN: `https://nid.naver.com/nidlogin.login?realname=Y&svctype=${NID_SVC_TYPE}&url=`,
  LOGOUT: `https://nid.naver.com/nidlogin.logout?svctype=${NID_SVC_TYPE}&url=`,
  MAPS_APP_ANDROID_STORE: 'https://play.google.com/store/apps/details?id=com.nhn.android.nmap',
  MAPS_APP_IOS_STORE: 'https://apps.apple.com/kr/app/naver-map-navigation/id311867728',
  MAP_3: 'https://ssl.pstatic.net/sstatic.map/openapi/maps3.js',
  MAP_3_GL_PLUGIN: 'https://ssl.pstatic.net/sstatic.map/openapi/maps3-gl.js',
  MAP_CUSTOMER_SERVICE: 'https://help.naver.com/service/5637?lang=ko',
  ME_AGREEMENT: 'https://nid.naver.com/mobile/user/help/realNameCheck.nhn',
  MISSION_SURVEY: 'https://naver.me/FsKabmCD',
  NEW_HOME_SURVEY: 'https://naver.me/IGKnGwc8',
  HOTEL_REVIEW_PROMOTION: 'https://campaign.nbilly.naver.com/hotelreview_event_jan',
  VISIT_DETAIL_SURVEY: 'https://naver.me/F2iXzsLP',
  MISSION_BEST_REVIEWER_SURVEY: 'https://naver.me/IGG6KU5Z',
  MYPLACE_POLICY: 'https://m.place.naver.com/my/policy',
  MY_INFO: 'https://nid.naver.com/mobile/user/help/naverProfile.nhn',
  NAVER: 'https://m.naver.com',
  NAVER_APP_ANDROID_STORE: 'https://play.google.com/store/apps/details?id=com.nhn.android.search',
  NAVER_APP_IOS_STORE: 'https://apps.apple.com/kr/app/%EB%84%A4%EC%9D%B4%EB%B2%84-naver/id393499958',
  NAVER_CORP: 'https://www.navercorp.com/',
  NAVER_INOTI: 'https://right.naver.com',
  NAVER_RULES_SERVICE: 'https://policy.naver.com/rules/service.html',
  NAVER_RULES_SERVICE_GROUP: 'https://policy.naver.com/rules/service_group.html',
  NOTIFY: 'https://m.notify.naver.com/setting/detail',
  PANORAMA: 'https://m.map.naver.com/viewer/panorama.nhn?street=on&pinType=site&pinId=',
  PAYMENT_REPORT: 'https://help.naver.com/alias/myplace/myplace_77.naver',
  PERMERNANT_BANNED: 'https://help.naver.com/alias/myplace/myplace_12.naver',
  PHOTO_INFRA_COMMON: 'https://search.pstatic.net/common/?',
  PRIVACY_MOBILE: 'https://policy.naver.com/policy-mobile/privacy.html',
  PRIVACY_PC: 'https://policy.naver.com/rules/privacy.html',
  HERE_NOWADAYS: 'https://m.naver.com/naverapp/?version=3&cmd=onMenu&menuCode=SHOP-TODO',
  REPLY_GUIDE_LINK: 'https://m.blog.naver.com/nv_placemy/222131304637',
  REVIEW_GUIDE: 'https://m.cafe.naver.com/naverplace/1246',
  SERVICE_NOTICE: 'https://m.blog.naver.com/nv_placemy',
  MYPLACE_SMART_BOT: 'https://talk.naver.com/ct/w4oazk',
  SMART_BOT: 'https://talk.naver.com/ct/w4te72',
  SMART_PLACE_CUSTOMER_SERVICE: 'https://help.naver.com/support/alias/myplace/myplace_17.naver',
  SUGGEST: 'https://help.naver.com/alias/myplace/myplace_74.naver',
  TALK: 'https://talk.naver.com/wcewpp',
  TEMPORARY_BANNED: 'https://help.naver.com/alias/myplace/myplace_11.naver',
  REPORT_REVIEWER:
    'https://help.naver.com/support/inquiry/input.help?categoryNo=17335&serviceNo=19485&reviewid1=&reviewer11=&placeNo1=',
  CHECK_IN_HELP: 'https://help.naver.com/alias/myplace/myplace_83.naver',
  RIGHT_PROTECT_CENTER: 'https://right.naver.com',
  HELP_ILLEGAL_FILMING: 'https://help.naver.com/service/30001/contents/17524?lang=ko',
  TEMPORARY_SUSPENSION_NOTICE: 'https://help.naver.com/service/19485/contents/14828?osType=MOBILE&lang=ko',
  TOUR_CUSTOMER_SERVICE: 'https://help.naver.com/service/30031/category/bookmark?lang=ko',
} as const

export default commonLinks
